import React from 'react';
import UvalueCalculator from './UvalueCalculator.js';
import { AuthProvider, useData } from './AuthContext.js';
import OfflinePage from './OfflinePage.js';

const RootInner = () => {
  const { isOnline } = useData();

  if (!isOnline) {
    return <OfflinePage />;
  }

  return <UvalueCalculator />;
};

const App = () => (
  <AuthProvider>
    <RootInner />
  </AuthProvider>
);

export default App;
